import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useTranslation } from '../i18n/i18n';
import useOnlineStatus from '../hooks/useOnlineStatus';
import { ReactComponent as CloudOfflineOutline } from '../assets/icons/cloud_offline_outline.svg';

export default function LogoutConfirmationModal({ onCancel, onConfirm }) {
  const { currentUser } = useContext(AuthContext);
  const { t } = useTranslation(currentUser?.info?.languageCode);
  const isOnline = useOnlineStatus();

  return (
    <div className='fixed inset-0 z-[1000] bg-black/70 backdrop-blur-sm flex justify-center items-center animate-fadein'>
      <div className='rounded-3xl dark:border dark:border-[#3C3E53] bg-[#FFFFFFF2] dark:bg-[#2E3440] shadow-[58px_41px_42px_0_rgba(0,0,0,0.07),_6px_5px_17px_0_rgba(0,0,0,0.13)] dark:shadow-[0_10px_15px_-3px_rgba(0,0,0,0.10)] p-6 flex flex-col gap-2 max-w-[25rem] w-full relative animate-popup'>
        <div className='flex flex-col gap-6'>
          <p className='text-xl font-semibold text-[#0D0D0D] dark:text-[#FAFAFA] text-center px-5 whitespace-pre-line'>
            {isOnline ? t('feed_timestamping_confirm_logout') : t('feed_timestamping_logout_modal_title')}
          </p>

          {!isOnline && (
            <div className='flex flex-col gap-4'>
              <div className='flex items-center gap-2 py-2 px-3 rounded-lg dark:bg-[#3C4353] bg-[#E8E8EA] mx-auto'>
                <CloudOfflineOutline className='size-[18px] shrink-0 text-[#454756] dark:text-[#FAFAFA]' />
                <span className='text-base text-[#454756] dark:text-[#FAFAFA]'>
                  {t('feed_timestamping_logout_offline_badge')}
                </span>
              </div>
              <div className='flex flex-col gap-2'>
                <p className='text-base text-[#4B4B4B] dark:text-[#CAD5E2] text-center whitespace-pre-line'>
                  {t('feed_timestamping_logout_offline_relogin')}
                </p>
                <p className='text-base font-medium text-[#2D3041] dark:text-[#FAFAFA] text-center whitespace-pre-line'>
                  {t('feed_timestamping_logout_unsaved_changes')}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className='flex items-center justify-end gap-3 mt-6'>
          <button
            type='button'
            className='h-12 min-w-[10.625rem] rounded-lg flex items-center justify-center border border-[#E1E1E1] dark:border-[#3C3E53] bg-[#FAFAFA] hover:bg-[#F5F5F5] active:bg-[#E1E1E1] dark:bg-[#0C121D] dark:hover:bg-[#1A202E] dark:active:bg-[#0C121D] py-2 px-4 text-lg leading-[120%] font-medium dark:text-[#CAD5E2] box-border transition-all duration-300'
            onClick={() => onCancel?.()}
          >
            {t('common_cancel')}
          </button>
          <button
            type='button'
            className='h-12 min-w-[10.625rem] rounded-lg flex items-center justify-center bg-[#DA1E28] hover:bg-[#C41A24] active:bg-[#DA1E28] dark:bg-[#E04B4B] dark:hover:bg-[#D32F2F] dark:active:bg-[#E04B4B] py-2 px-4 text-lg leading-[120%] font-medium text-[#FFFFFF] dark:text-[#FAFAFA] box-border transition-all duration-300'
            onClick={() => onConfirm?.()}
          >
            {t('common_logout')}
          </button>
        </div>
      </div>
    </div>
  );
}
